<template>
  <div :class="{'layout-wrap': true, 'slidbar-close': !isSlidbarOpen}">
    <div class="wrap-left">
      <div class="slidbar-wrap">
        <div class="flex logo-title">
          <img
            class="logo"
            src="../assets/images/logo.png"
            alt=""
          />
          <img
            v-if="isSlidbarOpen"
            class="title"
            src="@/assets/images/system-title.png"
            alt=""
          />
        </div>
        <el-menu
          ref="sidebarMenu"
          :default-active="activeMenuPath"
          :collapse="!isSlidbarOpen"
          :collapse-transition="false"
          @select="handleMenuSelect"
        >
          <Slidbar :list="defaultRouter" />
        </el-menu>
      </div>
    </div>
    <div class="wrap-right">
      <Header></Header>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import Header from './components/Header.vue';
import Slidbar from './components/Slidbar.vue';
import {mapState} from 'vuex';
export default {
  components: {
    Header,
    Slidbar
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('config', ['isSlidbarOpen']),
    ...mapState('routerV', ['defaultRouter']),
    activeMenuPath() {
      return this.$route.meta.activeMenu || this.$route.path;
    }
  },
  methods: {
    // 需要在 nextTick 中根据实际路由同步菜单选中状态
    handleMenuSelect() {
      this.$nextTick(() => {
        if (this.$refs.sidebarMenu && this.$refs.sidebarMenu.activeIndex !== undefined) {
          this.$refs.sidebarMenu.activeIndex = this.$route.path;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@leftWidth: 248px;
@colLeftWidth: 74px;
.layout-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  .wrap-left {
    width: @leftWidth;
    transition: all 0.3s;
    .slidbar-wrap {
      height: 100%;
      display: flex;
      flex-direction: column;
      background: #fff;
      border-right: 1px solid @border-color;
      padding: 0 8px;
      box-sizing: border-box;
      .logo-title {
        justify-content: center;
        align-items: center;
        padding: 8px 0 16px;
        .logo {
          width: 36px;
        }
        .title {
          width: 167px;
          margin-left: 7px;
        }
      }
      .el-menu {
        flex: 1;
        overflow-y: auto;
        max-width: 100% !important;
        border-right: none !important;
      }
    }
  }
  .wrap-right {
    width: calc(100% - @leftWidth);
  }
  &.slidbar-close {
    .wrap-left {
      width: @colLeftWidth;
    }
    .wrap-right {
      width: calc(100% - @colLeftWidth);
    }
  }
}
@media screen and (max-width: 1000px) {
  .wrap-left {
    width: 0 !important;
    overflow: hidden;
    opacity: 0;
  }
  .wrap-right {
    width: 100% !important;
  }
}
</style>
